import { render, staticRenderFns } from "./HeaderSmallScreen.vue?vue&type=template&id=077e643a&scoped=true&"
import script from "./HeaderSmallScreen.vue?vue&type=script&lang=js&"
export * from "./HeaderSmallScreen.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSmallScreen.vue?vue&type=style&index=0&id=077e643a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e643a",
  null
  
)

export default component.exports